import { render } from "./FooterNew.vue?vue&type=template&id=41e4bbb2&scoped=true"
import script from "./FooterNew.vue?vue&type=script&lang=js"
export * from "./FooterNew.vue?vue&type=script&lang=js"

import "./FooterNew.vue?vue&type=style&index=0&id=41e4bbb2&scoped=true&lang=scss"

import exportComponent from "/var/www/test.adx-co.jp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41e4bbb2"]])

export default __exports__